import styled from "styled-components";

export const BorderDecoratedCardWrapper = styled.div`
    display: flex !important;
    flex-direction: column;
    align-items: stretch;
    overflow: hidden;
    padding: 10px;
    box-sizing: border-box;
    background: url(static/images/big-screen/electric-wheel/card-border.png);
    background-size: 100% 100%;
`;

export const Title = styled.div`
    flex: 0 0 auto;
    display: flex; 
    flex-direction: row;
    align-items: flex-end;
    height: 30px;
    box-sizing: border-box;
    color: rgb(189, 226, 243);
`;

export const TitleCn = styled.div`
    font-size: 16px;
    font-weight: normal;
    font-style: normal;
    letter-spacing: 4px;
    width: 50%;
    padding-left: 50px;
    padding-bottom: 5px;
`;

export const TitleEn = styled.div`
    font-size: 12px;
    font-weight: normal;
    font-style: normal;
    letter-spacing: 2px;
    padding-bottom: 5px;
    font-family: Rajdhani;
`;

export const TitleBorder = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 20px;
`;

export const Content = styled.div`
    flex: 1 1 0px;
    overflow: hidden;
`;

